import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Problem", href: "#problem" },
  { label: "Fail-Safe", href: "#failsafe" },
  { label: "Engineering", href: "#engineering" },
  { label: "Compare", href: "#compare" },
  { label: "Specs", href: "#specs" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-xl border-b border-[#C8D3DF] shadow-sm"
          : "bg-white/80 backdrop-blur-md border-b border-[#C8D3DF]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="MPS Multi Parts — home"
        >
          <div className="bg-white rounded-md px-2.5 py-1.5 flex items-center justify-center shadow-[0_0_18px_rgba(91,155,213,0.15)] group-hover:shadow-[0_0_22px_rgba(91,155,213,0.35)] transition-shadow">
            <img
              src="/assets/mps-logo.png"
              alt="MPS Multi Parts logo"
              className="h-8 w-auto object-contain"
            />
          </div>
          <span className="hidden sm:flex font-mono text-[10px] text-[#8896A6] tracking-[0.18em] uppercase">
            Engineered · USA
          </span>
        </a>

        {/* Desktop links */}
        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-chivo text-xs uppercase tracking-[0.18em] text-[#536073] hover:text-[#5B9BD5] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href="#cta"
          data-testid="nav-distributor-cta"
          className="hidden lg:inline-flex btn-tech"
        >
          Get an offer
          <span aria-hidden>→</span>
        </a>

        {/* Mobile toggle */}
        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#1A2232] p-2 border border-[#C8D3DF] rounded-sm"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden border-t border-[#C8D3DF] bg-white/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-chivo text-sm uppercase tracking-[0.18em] text-[#536073] hover:text-[#5B9BD5]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#cta"
              onClick={() => setOpen(false)}
              className="btn-tech justify-center mt-2"
            >
              Get an offer →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
